import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';

export class ObjectProperties implements IGenericAccessor {
    private dataMap: { [id: string]: any } = {};
    private keys: { [id: string]: boolean } = {};

    constructor(data: any, useApi?: boolean) {
        if (useApi) {
            for (const item in data) {
                this.dataMap[item] = data[item];
                this.keys[item] = true;
            }
        } else {
            for (const item of data) {
                if (item) {
                    this.dataMap[item.FieldName] = item.FieldValue;
                    this.keys[item.FieldName] = true;
                }
            }
        }
    }

    public contains(fieldName: string): boolean {
        return this.keys[fieldName];
    }

    public getAs<T>(fieldName: string): T {
        if (this.keys[fieldName]) {
            return this.dataMap[fieldName];
        }
        return null;
    }

    public get(fieldName: string): any {
        return this.getAs<any>(fieldName);
    }

    public set(fieldName: string, fieldValue: any) {
        this.keys[fieldName] = true;
        this.dataMap[fieldName] = fieldValue;
    }

    public getMetaData(): { [id: string]: number } {
        const ret = {};
        for (const key in this.dataMap) {
            const knownType = KnownPropertyTypes.for(key);
            if (knownType) {
                ret[key] = knownType;
            } else {
                ret[key] = DataType.guess(this.dataMap[key]);
            }
        }
        return ret;
    }

    public getRawValue(field: string): any {
        return this.get(field);
    }
}
